import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetClientePorIdService } from '@/http/get-cliente-por-id.service'
import type { TCliente } from '@/types/cliente'
import { clientePorCpfPropostaKeys } from '@/utils/cliente-query-keys'

export const useClientePorId = (id: string, enabled: boolean): UseQueryResult<TCliente, AxiosError> => {
  return useQuery({
    queryKey: clientePorCpfPropostaKeys.obter(id),
    queryFn: async () => new GetClientePorIdService().execute({ id }).then((res) => res.data),
    enabled: enabled,
  })
}
